import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { deleteOrder, getOrdersList, updateOrder, getTripById, broadcastTrip, getActiveDrivers, 
  sendTirpByDriverId, assignTripByDriverId,getRiderHighBalances } from './shared/api/user';
import { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import "./Order.css";
import tone from '../src/audio/notify.mp3';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

// const tripStatus = [
//   'CREATED',
//   'ARRIVED',
//   'STARTED',
//   'COMPTELED',
//   'CANCELLED',
// ];

// const orderStatus = [
//   'PENDING',
//   'ACCEPTED',
//   'IN_PROGRESS',
//   'COMPTELED',
//   'CANCELLED',
// ];

export default function BasicTable() {
  const [orders, setOrders] = useState([]);
  const [trip, setTrip] = useState({});
  const [Offset, setOffset] = useState(0);
  const previousOrdersRef = useRef([]);
  const navigate = useNavigate();
  const [isNewOrderAdded, setIsNewOrderAdded] = useState(false);
  const [notificationSent, setNotificationSent] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [selectedTripId, setSelectedTripId] = useState('');
  const [open, setOpen] = useState(false);
  // const [openOrderStatus, setOpenOrderStatus] = useState(false);
  const location = useLocation();
  const divRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState({});
  const [riderAlerts, setRiderAlerts] = useState([]);
  const [openRiderDialog, setOpenRiderDialog] = useState(false);
const [riderList, setRiderList] = useState([]);

  const handleClose = () => {
    setOpen(false);
  };

  const init = async () => {
    let rows = await getOrdersList(Offset);
    setOrders(rows.data.orders);
    console.log('rows.data',rows.data)

    const newOrders = rows.data.orders.filter(order => !previousOrdersRef.current.some(prevOrder => prevOrder._id === order._id));

    if (newOrders.length > 0) {
      const latestOrderTimestamp = moment(newOrders[0].createdAt).valueOf();
      const lastNotificationTimestamp = localStorage.getItem('lastNotificationTimestamp');
      if (lastNotificationTimestamp === null || latestOrderTimestamp > Number(lastNotificationTimestamp)) {
        setIsNewOrderAdded(true);
        setNotificationSent(false);
        localStorage.setItem('lastNotificationTimestamp', latestOrderTimestamp);
      }
    }
    previousOrdersRef.current = rows.data.orders;

    const saved = sessionStorage.getItem(`${location.pathname}-scrollPos`);
    if (saved) {
      const { scrollPosition, timestamp } = JSON.parse(saved);

      // Clear the scroll position if it's older than 6 hours (21600000 milliseconds)
      if (Date.now() - timestamp > 21600000) {
        sessionStorage.removeItem(`${location.pathname}-scrollPos`);
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }
  }

  useEffect(() => {
    init();
    checkHighBalanceRiders();

    const interval = setInterval(() => {
      init();
      checkHighBalanceRiders();

    }, 25000);
    const previousOrders = JSON.parse(localStorage.getItem('previousOrders'));
    previousOrdersRef.current = previousOrders || [];
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isNewOrderAdded && !notificationSent) {
      showNotification();
      setNotificationSent(true);
    }
  }, [isNewOrderAdded, notificationSent]);

  const showNotification = async () => {
    let audio = new Audio(tone);
    setTimeout(() => {
      audio.play();
      notify();
    }, 1000)
  }
  const notify = () => toast('A new order has been received.');

  async function deleteOrderById(id) {
    let status = await deleteOrder(id);
    init();
  }

  async function paginationClickedNext() {
    setOffset(Offset + 150);
    init();
  }

  async function paginationClickedPrev() {
    if (Offset > 0) {
      setOffset(Offset - 150);
      init();
    }
  }

  const getTripDetails = async (tripId) => {
    if (tripId) {
      let trip = await getTripById(tripId);
      setTrip(trip);
    }
  }

const checkHighBalanceRiders = async () => {
  return
  try {
    const res = await getRiderHighBalances();
    console.log('rider earning', res);

    if (Array.isArray(res) && res.length > 0) {
      const formatted = res.map(item => ({
        name: `${item.driver?.firstName ?? ""} ${item.driver?.lastName ?? ""}`.trim(),
        phoneNumber: item.driver?.phoneNumber ?? "N/A",
        totalAmount: item.totalAmount ?? 0,
        status: item.status ?? "",
        source: item.sourceAddress ?? "",
        destination: item.destinationAddress ?? ""
      }));

      console.log("Formatted Result:", formatted);
      setRiderList(formatted);

      // Filter high-balance riders (>= 6000)
      const highBalanceRiders = formatted.filter(r => r.totalAmount >= 6000);

      if (highBalanceRiders.length > 0) {
        const names = highBalanceRiders.map(r => r.name).join(", ");
        const message =
          highBalanceRiders.length === 1
            ? `⚠️ ${names} has a high balance.`
            : `⚠️ The following riders have high balances:\n${names}`;
        toast.error(message, { duration: 5000 });
      }
    }
  } catch (err) {
    console.error('Rider balance check failed:', err);
  }
};

const playRiderAlertSound = () => {
  const audio = new Audio(tone);
  audio.play().catch(() => {});
};


const broadcastTripById = async (tripId) => {
  await broadcastTrip(tripId);
  }

  const handleScroll = () => {
    const currentScrollPosition = divRef.current.scrollTop;
    console.log(currentScrollPosition)
    setScrollPosition(currentScrollPosition); // Update state with the scroll position
  };

useEffect(() => {
    const divElement = divRef.current;
    console.log(divElement)
    if (divElement) {
      // Add event listener to track scrolling
      divElement.addEventListener("scroll", handleScroll);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const details = async (id) => {
    const scrollPosition = window.scrollY;
    const timestamp = Date.now();
    sessionStorage.setItem(`${location.pathname}-scrollPos`, JSON.stringify({ scrollPosition, timestamp }));
    navigate(`/order/${id}`);
  }

  async function updateOrderById(id) {
    try {
      updateOrder(id, { orderStatus: 'ACCEPTED' });
      toast('Order Accepted');
      init();
    }
    catch (err) {
      console.log(err)
      await updateOrder(id, { orderStatus: 'PENDING' });
      setError(`There is an issue with this user payment. ${err.response.data.status.message.raw.message}`);
      setTimeout(() => {
        setError('');
      }, 6000);
    }
  }

  async function paginationClicked(e) {
    setOffset(Number(e.target.innerText * 10))
    let rows = await getOrdersList(Offset);
    setOrders(rows.data.orders);
  }

  const getDrivers = async (id) => {
    setSelectedTripId(id);
    let drivers = await getActiveDrivers(id);
    setDrivers(drivers.drivers);
    console.log(drivers);
    setOpen(true);
  }

  // const updateOrderStatusCustom = async (id) => {
  //   setOpenOrderStatus(true);
  // }

  const sendTripToDriverById = async (driverId) => {
    let trip = await sendTirpByDriverId(selectedTripId, driverId);
    console.log(trip)
    setOpen(false);
  }

  const assignTrip = async (driverId) => {
    let trip = await assignTripByDriverId(selectedTripId, driverId);
    console.log(trip)
    setOpen(false);
  }

  return (
    <>
      <TableContainer ref={divRef} component={Paper}  sx={{
    width: '100%',
    overflow: 'auto', // Enables both horizontal and vertical scrolling
    maxHeight: 'calc(100vh - 150px)', // Adjust 200px based on your header/footer
    display: 'block',
    position: 'relative' // Helps with scrollbar positioning
  }}>
        <Table sx={{ 
    minWidth: 'max-content',
    tableLayout: 'fixed' // Makes column widths consistent
  }}  aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Restaurant Name</TableCell>
              <TableCell align="right">Customer Name</TableCell>
               <TableCell align='right'>City</TableCell>
              <TableCell align="center">Trip Status</TableCell>
              <TableCell align="center">Broadcast Trip</TableCell>
              <TableCell align="center">Order Status</TableCell>
              <TableCell align="center">Order Type</TableCell>
              <TableCell align="center">Payment Status</TableCell>
              <TableCell align="center">Total Price</TableCell>
              <TableCell align="center">Contact Restaurant</TableCell>
              <TableCell align="center">Order Action</TableCell>
              <TableCell align="center">Trip Action</TableCell>
              <TableCell align="center">Status Action</TableCell>
              {/* <TableCell align="center">Delete Order</TableCell> */}
              <TableCell align="right">Order Time</TableCell>
              <TableCell align="right">Onboard Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders?.map((row) => (
              <TableRow
                key={row._id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {row?.chef?.restaurantName && <TableCell onClick={() => details(row._id)} component="th" scope="row">
                  {row?.chef?.restaurantName}
                </TableCell>}
                {!row.chef?.restaurantName && <TableCell onClick={() => details(row._id)} component="th" scope="row">
                  {row?.chef?.firstName} {row?.chef?.lastName}
                </TableCell>}
                {/* <TableCell onClick={() => details(row._id)} align="right">{row?.user?.firstName} {row?.user?.lastName || ''}</TableCell> */}
                <TableCell onClick={() => details(row._id)} align="right">
                  {row?.user?.firstName ? `${row?.user?.firstName} ${row?.user?.lastName || ''}` : row?.customerName || 'N/A'}
                </TableCell>
                 <TableCell onClick={() => details(row._id)} align="right">
                      {row?.city || "N/A"}
                </TableCell>
                {row.tripId !== trip._id && row.orderType === 'DELIVERY' && <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => getTripDetails(row.tripId)} variant="text">Check Status</Button></TableCell>}
                {row.orderType === 'PICKUP' && <TableCell align="right">No Trip</TableCell>}
                {trip.status && trip._id == row.tripId && <TableCell align="right">{trip.status}</TableCell>}
                {row.tripId !== trip._id && row.orderType === 'DELIVERY' && <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => getTripDetails(row.tripId)} variant="text">Check Status</Button></TableCell>}
                {row.tripId === trip._id && trip.status === 'CREATED' && row.orderType === 'DELIVERY' && row.orderStatus !== 'COMPLETED' && <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => broadcastTripById(row.tripId)} variant="text">Broadcast</Button></TableCell>}
                {row.tripId === trip._id && trip.status === 'COMPLETED' && row.orderType === 'DELIVERY' && row.orderStatus === 'COMPLETED' && <TableCell align="right">COMPLETED</TableCell>}
                {row.tripId === trip._id && row.orderType === 'DELIVERY' && row.orderStatus === 'CANCELLED' && <TableCell align="left">TRIP CANCELLED</TableCell>}
                {row.tripId === trip._id && trip.status === 'STARTED' && row.orderType === 'DELIVERY' && row.orderStatus === 'IN_PROGRESS' && <TableCell align="right">IN PROGRESS</TableCell>}
                {row.orderType === 'PICKUP' && <TableCell align="right">NO DATA</TableCell>}
                <TableCell onClick={() => details(row._id)} align="right">{row?.orderStatus}</TableCell>
                <TableCell onClick={() => details(row._id)} align="right">{row?.orderType}</TableCell>
                <TableCell onClick={() => details(row._id)} align="right">{row?.paymentStatus}</TableCell>
                <TableCell onClick={() => details(row._id)} align="right">{`Rs. ${(row.serviceFee + row.total).toFixed(2)}`}</TableCell>
                <TableCell onClick={() => details(row._id)} align="right">{row?.chef?.phoneNumber}</TableCell>
                {row.orderStatus === 'PENDING' && <TableCell align="left">Not Accepted</TableCell>}
                {row.orderStatus === 'ACCEPTED' && <TableCell align="left">Accepted</TableCell>}
                {row.orderStatus === 'IN_PROGRESS' && <TableCell align="left">In progress</TableCell>}
                {row.orderStatus === 'COMPLETED' && <TableCell align="left">COMPLETED</TableCell>}
                {row.orderStatus === 'CANCELLED' && <TableCell align="left">CANCELLED</TableCell>}
                {row.orderType === 'DELIVERY' && <TableCell align="left"><Button sx={{ color: '#CB2704' }} onClick={() => getDrivers(row.tripId)} variant="text">Get Drivers</Button></TableCell>}
                {row.orderType === 'PICKUP' && <TableCell align="left">No Action</TableCell>}
                {/* <TableCell disabled align="left"><Button sx={{ color: '#CB2704' }} variant="text">Update Status</Button></TableCell> */}
                {/* MK */}
                <TableCell align="left">
                  <select 
                    value={selectedStatus[row._id] || ''} 
                    onChange={(e) => setSelectedStatus({...selectedStatus, [row._id]: e.target.value})}
                    style={{marginRight: '10px', padding: '5px'}}
                  >
                    {/* <option value="">Select Status</option>
                    <option value="COMPLETED">Completed</option>
                    <option value="IN_PROGRESS">In-Progress</option>  */}
                    <option value="">Select Status</option>
                    {row.orderStatus !== 'COMPLETED' && <option value="COMPLETED">Completed</option>}
                    {row.orderStatus !== 'IN_PROGRESS' && <option value="IN_PROGRESS">In-Progress</option>}    
                  </select>
                <Button 
                  sx={{ color: '#CB2704' }} 
                  onClick={async () => {
                    if (!selectedStatus[row._id]) {
                      toast.error('Please select a status first');
                      return;
                    }
                    
                    // Validation checks
                    if (selectedStatus[row._id] === 'COMPLETED' && row.orderStatus === 'COMPLETED') {
                      toast.error('Order is already completed');
                      return;
                    }
                    
                    if (selectedStatus[row._id] === 'IN_PROGRESS' && row.orderStatus === 'IN_PROGRESS') {
                      toast.error('Order is already in progress');
                      return;
                    }
                    
                    try {
                      await updateOrder(row._id, { orderStatus: selectedStatus[row._id] });
                      toast.success(`Order status updated to ${selectedStatus[row._id]}`);
                      init(); // Refresh the table
                    } catch (error) {
                      toast.error('Failed to update order status');
                      console.error('Update error:', error);
                    }
                  }} 
                  variant="text"
                >
                  Update Status
                </Button>
                </TableCell>
                {/* <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => deleteOrderById(row._id)} variant="text"><DeleteIcon></DeleteIcon></Button></TableCell> */}
                <TableCell onClick={() => details(row._id)} align="right">{moment(row.createdAt).format('DD/MM/YYYY hh:mm A')}</TableCell>
                <TableCell onClick={() => details(row._id)} align="center">
                  {row?.receiver?.isOnboarded ? "Onboard" : ""}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box textAlign='center'>
          <Button sx={{ color: '#CB2704' }} onClick={() => paginationClickedNext()} variant="text">Load next</Button>
          {Offset > 0 && <Button sx={{ color: '#CB2704' }} onClick={() => paginationClickedPrev()} variant="text">Load previous</Button>}
        </Box>
        <Toaster />
      </TableContainer>
      <BootstrapDialog
        onClose={handleClose}
        fullWidth={true}
        maxWidth={'md'}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Available Drivers
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Driver Name</TableCell>
                  <TableCell align="left">Phone</TableCell>
                  <TableCell align="left">Vehicle Type</TableCell>
                  <TableCell align="right">Send Trip</TableCell>
                  <TableCell align="right">Assign Trip</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {drivers?.map((row) => (
                  <TableRow
                    key={row._id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.firstName} {row?.lastName || ''}</TableCell>
                    <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.phoneNumber}</TableCell>
                    <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.vehicle.type}</TableCell>
                    <TableCell align="right" style={{ cursor: 'pointer' }}><Button sx={{ color: '#CB2704' }} onClick={() => sendTripToDriverById(row._id)} variant="text">Send Trip Request</Button></TableCell>
                    <TableCell align="right" style={{ cursor: 'pointer' }}><Button sx={{ color: '#CB2704' }} onClick={() => assignTrip(row._id)} variant="text">Assign Trip</Button></TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </BootstrapDialog>

   <BootstrapDialog
  onClose={() => setOpenRiderDialog(false)}
  fullWidth
  maxWidth="sm"
  open={openRiderDialog}
>
  <DialogTitle>
    ⚠️ Riders with High Balance (≥ 6000 PKR)
  </DialogTitle>
  <DialogContent dividers>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>Name</strong></TableCell>
            <TableCell><strong>Phone Number</strong></TableCell>
            <TableCell align="right"><strong>Amount (PKR)</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {riderAlerts.map((r, idx) => (
            <TableRow key={idx}>
              <TableCell>{r.name}</TableCell>
              <TableCell>{r.phone}</TableCell>
              <TableCell align="right">{r.amount.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </DialogContent>
</BootstrapDialog>
<Toaster position="top-right" reverseOrder={false} />
    </>
  );
}